import React from "react";
import CreateRoom from "../components/CreateRoom";

const CreateRoomPage = () => {
  return <CreateRoom />;
};

export default CreateRoomPage;
